import { useContext } from 'react';
import { AdministradoraContextData } from '../types/context';
import { AdministradoraContext } from '../context/cadastroDeAdministradoraContext';

export const useAdministradora = (): AdministradoraContextData =>
  useContext(AdministradoraContext);
